import { ROUTES } from '@router'

import { PAGE_TYPE_BY_ROUTE_NAME } from './service/content-service.config'

// Block that are displayed by default without being configured via the CMS
export const DEFAULT_BLOCK_TYPE = {
  BREADCRUMB: 'Breadcrumb',
  HERO_BANNER: 'HeroBanner',
  HEADING: 'Heading',
}

export const DEFAULT_LAYOUT_FIELDS = {
  alternateLinks: [],
  pageType: '',
  pageName: '',
  pageCategory: '',
  parentPageInfos: {},
  title: '',
  badge: '',
  titleSeo: '',
  titleBreadcrumb: '',
  banner: {},
  meta: {
    title: '',
    description: '',
    alternateLinks: [],
    image: { src: '' },
  },
  textSeo: {},
  blocks: [],
  hideFromSearchEngine: false,
}

export const PAGE_TYPE_WITH_SPECIFIC_FIELDS = [
  PAGE_TYPE_BY_ROUTE_NAME[ROUTES.CMS.LEGAL_PAGE],
  PAGE_TYPE_BY_ROUTE_NAME[ROUTES.CMS.LEGAL_PREVIOUS_VERSION],
]
